import React from 'react';
import Navbar from '../gral-components/Navbar';
import Header from '../gral-components/Header';
import BorderCurved from '../gral-components/BorderCurved';
import Subtitles from '../gral-components/Subtitles';
import Professionals from './components/Professionals';
import Services from './components/Services';
import Testimonials from '../gral-components/Testimonials';
import BlogBox from '../gral-components/BlogBox';
import Trusted from '../gral-components/trusted';
import Footer from '../gral-components/Footer';
import '../gral-stylesheets/home.scss';


import dataDearHR from '../data/dearHR/unauthenticated.json';

import blogers from '../data/users/users-blog.json';



class Authenticated extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstname: '',
      update: false
    };
  }
  componentDidMount = () => {
    this.updateState();
  };
  componentDidUpdate = () => {
    if (this.state.update) {
      this.updateState();
      this.setState({ update: false })
    }
  };
  updateState = () => {
    let personalInfo = JSON.parse(localStorage.getItem('personalInfo'));
    this.setState({
      firstname: personalInfo ? personalInfo.firstname : 'User'
    });
  };
  render() {
    return (
      <div className='background-gradient-image'>
        <div
          id='header-home'
          className='header-authenticated'
        >
          <Navbar
            searchBar={true}
            testimonials={true}
            blog={true}
            firstname={this.state.firstname}
            navbarType='authenticated'
          />
          <section>
            <Header
              headerType='authenticated'
              images={blogers}
              textWriter={dataDearHR.textWriter.user}
              firstname={this.state.firstname}
            />
          </section>
        </div>
        <div className='main-content'>
          <div className='border-curved-top-container'>
            <BorderCurved
              transform={false}
              background={{
                backgroundImage: 'none'
              }}
              fill='white'
            />
          </div>
          <section
            id='professional'
            className='professional-section background-clear'>
            <div className='subtitles-container'>
              <Subtitles
                darkText={true}
                titleSmall='Connect with'
                titleBig='Professionals and Freelancers'
              />
            </div>
            <Professionals />
          </section>
          <section
            id='services'
            className='services-section background-dark'
          >
            <div className='subtitles-container'>
              <Subtitles
                darkText={true}
                titleSmall='Connect with'
                titleBig='Services'
              />
            </div>
            <Services />
          </section>
          <section
            id='testimonials'
            className='testimonials-section background-clear'
          >
            <div className='subtitles-container'>
              <Subtitles
                darkText={true}
                titleSmall='Happy Clients'
                titleBig='Testimonials'
              />
            </div>
            <Testimonials
              isDarkBackground={false}
            />
          </section>
          <section
            id='blog'
            className='blog-section background-dark'
          >
            <div className='subtitles-container'>
              <Subtitles
                darkText={true}
                titleSmall='Our Blog'
                titleBig='Recent post'
              />
            </div>
            <BlogBox
              isDarkBackground={false}
            />
          </section>
          <div
            id='trusted'
            className='trusted-section background-clear' >
            <Trusted />
          </div>
          <div className='border-curved-bottom-container'>
            <BorderCurved
              transform={true}
              background={{
                backgroundColor: 'rgba(0, 0, 0, 0.7)'
              }}
              fill='white'
            />
          </div>
        </div>
        <section
          id='footer'
          className='footer-section' >
          <Footer
            footerMini={false}
          />
        </section>
      </div>
    );
  }

};

export default Authenticated;